<script>
import { Helper } from '@/mixin/helper'
import { formatNumber } from '@/helpers/format-number'
import * as product from '@/services/rest-api-vsms/lib/product/product'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  mixins: [Helper, MixPanel],

  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    keyword: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      defaultImage: require('@/assets/images/default-image-user.png'),
      currentLimit: 6, // Default limit
      productList: [],
    }
  },

  computed: {
    filteredProductList() {
      return this.productList.map((product) => {
        const matchedCategory = this.categoryList.find(
          (category) => category.id === product.product_category_id
        )
        if (matchedCategory) {
          const parentCategory = this.categoryList.find(
            (category) => category.id === matchedCategory.parent_id
          )
          if (parentCategory) {
            product.subcategory = matchedCategory.name
            product.category = parentCategory.name
          } else {
            product.category = matchedCategory.name
          }
        }
        return product
      })
    },
    categoryList() {
      return this.$store.state.marketplace.categories
    },
  },

  watch: {
    list: {
      immediate: true,
      handler(newList) {
        this.productList = newList // Sinkronisasi dengan props
      },
    },
  },

  methods: {
    imageError(event) {
      event.target.src = '' // Ganti dengan URL gambar placeholder jika diinginkan
      event.target.style.backgroundColor = '#f0f0f0' // Warna latar belakang untuk menunjukkan tempat gambar
      event.target.style.display = 'block' // Tetap menampilkan elemen dengan ukuran yang diatur
    },

    formatProductPrice(price) {
      return formatNumber(price)
    },

    openDetailPage(moreLink, productName) {
      // Redirect ke halaman detail dengan more_link sebagai query parameter
      this.$router.push({
        name: 'Marketplace Product Detail',
        query: { externalLink: moreLink, productName: productName },
      })
    },

    async openProductAll(total, categoryId) {
      let _params = {
        limit: total, // Mengambil semua produk berdasarkan total yang diminta
        filters: [`product_category_id eq ${categoryId}`], // Berdasarkan category_id
      }

      if (this.keyword) {
        _params.search = this.keyword
      }

      const products = await product.get(_params)

      if (products && products.data && products.data.paginated_result) {
        // Perbarui productList dengan data terbaru
        this.productList = products.data.paginated_result // Ganti daftar produk dengan yang baru
        this.currentLimit = this.productList.length // Perbarui currentLimit
        this.productList.total = products.metadata.total_count // Set total produk
      }
    },
    openContactUsPage(contactPageURL, productName) {
      this.track('Click Marketplace Contact Us', {
        productName: productName,
      })
      window.open(contactPageURL, '_blank')
    },
  },
}
</script>

<template>
  <div>
    <b-card :title="title">
      <template v-if="filteredProductList.length > 0">
        <b-row class="mt-4 mx-n2 mc-marketplace-inline">
          <b-col
            v-for="product in filteredProductList"
            :key="product.id"
            md="4"
            sm="4"
            xl="2"
            lg="2"
            class="mb-4 mc-marketplace-inline__items"
          >
            <div>
              <img
                :src="product.image ? product.image : defaultImage"
                :alt="product.name"
                @error="imageError"
              />
              <div class="text-left mt-2">
                <h6>{{ product.name }}</h6>
                <p v-if="product.price" class="mb-0 mc-marketplace-inline__items-price">
                  {{ `Rp  ${formatProductPrice(product.price)}` }}
                </p>
              </div>
              <button
                v-if="product.chat_link"
                class="text-center mc-marketplace-inline__btn mc-marketplace-inline__btn--primary"
                @click="openContactUsPage(product.chat_link, product.name)"
              >
                {{ `${$t('marketplace.product.contactUs')}` }}
              </button>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-4 d-flex justify-content-center">
          <b-col md="4" xl="2" lg="4" sm="4" class="d-flex justify-content-center">
            <button
              v-if="productList.total > currentLimit"
              class="mc-marketplace-inline__btn"
              @click="openProductAll(productList.total, productList[0].product_category_id)"
            >
              {{ `${$t('marketplace.product.showOthers')}` }}
            </button>
            <button
              v-else
              class="mc-marketplace-inline__btn"
              @click="openProductAll(6, productList[0].product_category_id)"
            >
              {{ `${$t('marketplace.product.hide')}` }}
            </button>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-row class="mt-4">
          <h5 class="text-center">
            {{ $t('global.text.noData') }}
          </h5>
        </b-row>
      </template>
    </b-card>
  </div>
</template>
